import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from 'react-bootstrap';
import CalendarSingleRace from "./CalendarSingleRace";

function CalendarModal(props) {

    const mounted = useRef(false);
    const [show, setShow] = useState(false);
    const handleClose = () => props.handleClose();

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (mounted.current) {
            setShow(props.show);
        }
        else {
        }
    }, [props.refresh]);

    return <>
        <Modal key={'calendarModal' + show}
            size="xl"
            show={show}
            onHide={handleClose} >
            <Modal.Header>
            <Modal.Title>Race Overview</Modal.Title>
            <Button variant="danger py-0 m-0" onClick={handleClose}>{'X'}</Button>
            </Modal.Header>
            <Modal.Body closeButton style={{ backgroundColor: 'rgba(222,233,244,1)', padding: 0, margin: 0 }}>
                <CalendarSingleRace key={'calendar-' + props.selectedRaceEditionId + props.selectedRaceEditionStageNumber + show} 
                    selectedRaceEditionId={props.selectedRaceEditionId} 
                    raceId={props.raceId}
                    raceType={props.raceType} />
            </Modal.Body>
        </Modal>
    </>
}

export default CalendarModal;